const {createTheme} = require("@material-ui/core");

const AppTheme = createTheme({
    palette: {
        primary: {
            main: '#6366F1',
        },
    },
});

export default AppTheme;
